import { eventsRequest } from '../../utils/eventsRequest';
import { AxiosError } from 'axios';
import { CompleteOrderResponse, EnrollmentDetail, ErrorResponse, OrderPaymentType } from '../../types';
import { SESSION_KEY_ORDER_UUID } from '../../constants';
import { getUtmParams } from '../../utils';

const completeOrder = async (orderDetails: {
    orderPaymentType: OrderPaymentType;
    payerId: number;
    token: string;
    methodType: string;
}): Promise<{ success: boolean; message: string; enrollmentDetails: null | EnrollmentDetail[]; status: number }> => {
    let arrayResponse = {
        success: false,
        message: 'Order completion failed.',
        enrollmentDetails: null as EnrollmentDetail[] | null,
        status: 0,
    };

    try {
        const { orderPaymentType, payerId, token, methodType } = orderDetails;
        const utmParams = getUtmParams();
        
        const orderPayload: {
            isDeposit: boolean;
            orderPaymentType: OrderPaymentType;
            payerId: number;
            token: string;
            paymentMethod: string;
            utmParams?: Record<string, string>;
        } = {
            isDeposit: orderPaymentType === OrderPaymentType.DEPOSIT,
            orderPaymentType,
            payerId,
            token,
            paymentMethod: methodType.toUpperCase(),
        };

        // Add UTM params if they exist
        if (utmParams) {
            orderPayload.utmParams = utmParams;
        }

        const orderUuid = localStorage.getItem(SESSION_KEY_ORDER_UUID);

        if (!orderUuid) {
            return arrayResponse;
        }

        const response = await eventsRequest<CompleteOrderResponse>(`/orders/${orderUuid}/complete`, 'post', orderPayload);

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            arrayResponse.message = 'Order completed successfully.';
            arrayResponse.enrollmentDetails = response.data.data.enrollmentDetails; 
            arrayResponse.status = response.status;
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
            arrayResponse.message = axiosError.response.data.message || 'An error occurred during order completion.';
            arrayResponse.status = axiosError.response.status;
        }
        return arrayResponse;
    }
};

export default completeOrder;
